<template>
  <ExamDo @submit="onSubmit">
    <template v-slot:bread>
      <div class="bread">
        <router-link :to="{name:'ExamIndex'}">在线测评</router-link>
        <span class="slash">/</span>
        <span class="current">随机练习</span>
      </div>
    </template>
  </ExamDo>
</template>
<script>
import ExamDo from "./components/ExamDo.vue";
export default {
  name: "ExamRandomDo",
  components: {
    ExamDo
  },
  methods: {
    onSubmit() {
      this.$router.replace({
        name: "ExamRandomReport",
        query: {
          id: this.$route.query.id
        }
      });
    }
  }
};
</script>